import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { payment_status_path } from '@routes';
import { resumeSubscription } from '@utils/backend-api/resumeSubscription';

const useResumeSubscription = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(() => resumeSubscription(), {
    onSuccess: () => {
      window.location.href = payment_status_path({
        resume_subscription: true,
      });
    },
    onError: (error: { message: string }) => {
      toast.error(error.message);
    },
  });
  return { mutate, mutateAsync, isLoading, isError };
};

export default useResumeSubscription;
